import { render, staticRenderFns } from "./SSOCallback.vue?vue&type=template&id=287770af"
import script from "./SSOCallback.vue?vue&type=script&lang=ts"
export * from "./SSOCallback.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports